import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

interface DashboardSlice {
  dateRange: [string, string]; // Ensure type consistency
  timezone: string;
  rangeType: string;
  search: string;
}

export const dashboardInitialState: DashboardSlice = {
  dateRange: [
    dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
  ],
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  rangeType: "Day",
  search: "",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: dashboardInitialState,
  reducers: {
    setDateRange: (state, { payload }: PayloadAction<[string, string]>) => {
      state.dateRange = payload;
    },
    setTimezone: (state, { payload }: PayloadAction<string>) => {
      state.timezone = payload;
    },
    setRangeType: (state, { payload }: PayloadAction<string>) => {
      state.rangeType = payload;
    },
    setSearch: (state, {payload}: PayloadAction <string> ) => {
        state.search = payload
    }
  },
});

export const { setDateRange, setTimezone, setRangeType, setSearch } = dashboardSlice.actions;
export default dashboardSlice.reducer;
